export const ALLOWED_PATHS_FOR_LOCKED_ARTIST = [
  '/casting-billboard/:subNav?',
  '/project/:projectId',
  '/project/:projectId/role/:roleId',
  '/account-settings/details',
  '/membership-billing',
  '/default-redirect',
  '/maintenance',
  '/membership-billing/edit-billing-info',
  '/your-alerts',
];
